import { CSmartTable } from "@coreui/react-pro";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { capitalizeWords } from "../Components/allFunctions";

const Players = (props) => {
  const lang = props.Language;
  const { enterpriseId } = useParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [players, setPlayers] = useState([]);
  const [enterpriseInfo, setEnterpriseInfo] = useState({
    EnterpriseID: "",
    EnterpriseName: "",
  });

  const customTableFilterLabel = lang === "en" ? "Filter" : "筛选";
  const customItemsPerPageLabel =
    lang === "en" ? "Items per Page:" : "项目/页 : ";

  const columns = [
    {
      key: "id",
      label: "ID",
      filter: false,
      sorter: false,
      _style: { width: "5%" },
    },
    {
      key: "PlayerID",
      label: lang === "en" ? "Player ID" : "球员ID",
      _style: { width: "10%" },
      filter: true,
      sorter: true,
    },
    {
      key: "FirstName",
      label: lang === "en" ? "First Name" : "名",
      _style: { width: "15%" },
      filter: true,
      sorter: true,
    },
    {
      key: "LastName",
      label: lang === "en" ? "Last Name" : "姓",
      _style: { width: "15%" },
      filter: true,
      sorter: true,
    },
    {
      key: "Email",
      label: lang === "en" ? "Email" : "电子邮件",
      _style: { width: "20%" },
      filter: true,
      sorter: true,
    },
    {
      key: "TeamName",
      label: lang === "en" ? "Team Name" : "团队名称",
      _style: { width: "15%" },
      filter: true,
      sorter: true,
    },
    {
      key: "scanAvailable",
      label: lang === "en" ? "Scan Available" : "扫描状态",
      _style: { width: "10%" },
      filter: true,
      sorter: true,
    },
  ];

  useEffect(() => {
    setLoader(true);
    const base = process.env.REACT_APP_API_BASE_URL || "http://localhost:3003";
    const dashboardPath = "dashboard";

    fetch(`${base}/api/${dashboardPath}/enterprisePlayers/${enterpriseId}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status && res.data) {
          setEnterpriseInfo({
            EnterpriseID: res.data.EnterpriseID || "",
            EnterpriseName: res.data.EnterpriseName || "",
          });
          setPlayers(res.data.players || []);
        } else {
          setEnterpriseInfo({ EnterpriseID: "", EnterpriseName: "" });
          setPlayers([]);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error.message);
        setEnterpriseInfo({ EnterpriseID: "", EnterpriseName: "" });
        setPlayers([]);
        setLoader(false);
      });
  }, [enterpriseId]);

  return (
    <>
      <div className="container-fluid">
        {/* Header section */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span
            className="BackButton"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-arrow-left backbtn"></i>
          </span>
          <h1
            className="h3 mb-2 text-gray-800 HeadTitles"
            style={{ margin: 0 }}
          >
            {lang === "en" ? "Players" : "球员"}
          </h1>
        </div>

        {/* Enterprise Info Section */}
        <div style={{ marginTop: "10px", marginBottom: "20px" }}>
          <p style={{ margin: 0 }}>
            <strong>{lang === "en" ? "Enterprise ID:" : "企业ID:"}</strong>{" "}
            {enterpriseInfo.EnterpriseID}
          </p>
          <p style={{ margin: 0 }}>
            <strong>{lang === "en" ? "Enterprise Name:" : "企业名称:"}</strong>{" "}
            {capitalizeWords(enterpriseInfo.EnterpriseName)}
          </p>
        </div>

        {/* Table Section */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="mb-12 VendorTable">
              <CSmartTable
                activePage={1}
                responsive="true"
                tableFilter
                tableFilterPlaceholder={lang === "en" ? "Search..." : "搜索..."}
                tableFilterLabel={customTableFilterLabel}
                columns={columns}
                columnSorter
                loading={loader}
                items={players}
                itemsPerPageSelect
                itemsPerPage={10}
                itemsPerPageLabel={customItemsPerPageLabel}
                pagination
                tableProps={{
                  hover: true,
                  responsive: true,
                  striped: true,
                }}
                tableBodyProps={{
                  className: "align-middle",
                }}
                scopedColumns={{
                  id: (item, i) => <td>{i + 1}.</td>,
                  PlayerID: (item) => <td>{item?.PlayerID ?? ""}</td>,
                  FirstName: (item) => (
                    <td>{capitalizeWords(item?.FirstName ?? "")}</td>
                  ),
                  LastName: (item) => (
                    <td>{capitalizeWords(item?.LastName ?? "")}</td>
                  ),
                  Email: (item) => <td>{item?.Email ?? ""}</td>,
                  TeamName: (item) => (
                    <td>{capitalizeWords(item?.TeamName ?? "")}</td>
                  ),
                  scanAvailable: (item) => (
                    <td
                      style={{
                        color: item?.scanAvailable === 1 ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {item?.scanAvailable === 1
                        ? lang === "en"
                          ? "Yes"
                          : "是的"
                        : lang === "en"
                        ? "No"
                        : "不"}
                    </td>
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Toaster />
    </>
  );
};

export default Players;
